import { QueryClient, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getNotificationsQuery, markNotificationsReadQuery } from '../services/notificationService';
import { NotificationList, withRead } from './notificationTransforms';
import { queryKeys } from './queryKeys';

// What the app has told the signed-in person (the bell in the app bar). The server writes notifications when things
// happen; the app only reads them and marks them read.

const CHECK_EVERY_MS = 30_000;

export const notificationsOptions = () => ({
    queryKey: queryKeys.notifications(),
    queryFn: getNotificationsQuery,
    staleTime: CHECK_EVERY_MS / 2,
    // New ones appear without a reload. (React Query pauses this while the tab is in the background.)
    refetchInterval: CHECK_EVERY_MS,
});

export const useNotifications = () => useQuery(notificationsOptions());

// With no ids, marks all of them read.
export const markNotificationsReadMutation = (queryClient: QueryClient) => ({
    mutationFn: (ids?: string[]) => markNotificationsReadQuery(ids),
    onSuccess: (unreadCount: number, ids?: string[]) => {
        queryClient.setQueryData<NotificationList>(queryKeys.notifications(), (list) => withRead(list, ids, new Date().toISOString(), unreadCount));
    },
});

export const useMarkNotificationsRead = () => useMutation(markNotificationsReadMutation(useQueryClient()));
